import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageUsersPresenterComponent } from '.';
import { ManageUsersContainerComponent } from '.';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { ManageUsersRoute } from './manage-users.route';
import { ManageUsersBulkUpdatePresenterComponent } from './manage-users-bulk-update-presenter/manage-users-bulk-update-presenter.component';

@NgModule({
    declarations: [ManageUsersContainerComponent, ManageUsersPresenterComponent, ManageUsersBulkUpdatePresenterComponent],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [ManageUsersRoute]
        })
    ]
})
export class ManageUsersModule {}
